import * as Ladda from 'ladda';
import bsCustomFileInput from 'bs-custom-file-input';
import AOS from 'aos';
require('webpack-jquery-ui/effects');
import ServicesManager from '../util/tarteaucitron/ServicesManager';

export default {
  init() {
    // JavaScript to be fired on all pages

    // search form
    $('.search-form').on('submit', (e) => {
      let $form = $(e.currentTarget);
      let $searchField = $form.find('.search-field');

      if (!$searchField.hasClass('visible') || $searchField.val() === '') {
        e.preventDefault();
        $searchField.toggleClass('visible');
      }

      if ($searchField.hasClass('visible')) {
        $searchField.focus();
      } else {
        $searchField.blur();
      }
    });

    // tarteaucitron
    if (typeof window.tarteaucitron != 'undefined') {
      let tacManager = new ServicesManager();
      tacManager.addService('addtoanyshare', 'share-buttons', null, () => {
        document.getElementById('share-buttons').innerHTML =
          document.getElementById('share-buttons-template').innerHTML;
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // exit popups
    if ($('.exit-popup').length) {
      $('a[href]')
        .not($('#share-buttons a, .ignore-exit'))
        .each(function (linkIndex, linkItem) {
          let $a = $(linkItem);
          // display an exit popup for every outgoing link (i.e link href attribute different from current URL)
          let notLocalLink = new RegExp(
            '^(https?:)?//((?!' + window.location.host + ').)',
            'g'
          );
          if ($a.attr('href').match(notLocalLink)) {
            $a.on('click', function (evt) {
              let $selectedPopup;
              $('.exit-popup:not([data-default])').each(function (
                popupIndex,
                popupItem
              ) {
                let $popupItem = $(popupItem);
                let popupRegexpAttr = $popupItem.attr('data-regexp');
                if (popupRegexpAttr) {
                  let popupRegexp = new RegExp(popupRegexpAttr, 'g');
                  if ($a.attr('href').match(popupRegexp)) {
                    $selectedPopup = $popupItem;
                  }
                }
              });

              // if no popup with regexp matches the href, check for a default popup
              let $defaultPopup = $('.exit-popup[data-default]');
              if (!$selectedPopup && $defaultPopup.length) {
                $selectedPopup = $defaultPopup;
              }

              if ($selectedPopup) {
                evt.preventDefault();
                $selectedPopup.find('.btn-primary').one('click', function () {
                  window.open($a.attr('href'));
                });
                $selectedPopup.modal('show');
              }
            });
          }
        });
    }

    // confirmation popup
    let $confirmationPopup = $('.confirmation-popup:first');
    if ($confirmationPopup.length) {
      $confirmationPopup.modal('show');
    }

    // aos
    $('.wp-block-quote').attr('data-aos', 'fade-up');
    setTimeout(function () {
      AOS.init();
    }, 300);

    // append icons to gutenberg default blocks
    $('.wp-block-quote').prepend($('.icons-js > .quote-left').html());
    $('.wp-block-quote').append($('.icons-js > .quote-right').html());
    $('.wp-block-button')
      .not('.is-style-download-button')
      .find('.wp-block-button__link')
      .append($('.icons-js > .arrow-right').html());
    $('.is-style-download-button .wp-block-button__link').append(
      $('.icons-js > .download').html()
    );

    let iconBell = $('.icons-js > .bell');
    if (iconBell.length >= 1) {
      let group = $(
        `.wp-block-group.icon-bell .wp-block-group__inner-container:first, 
      .wp-block-group.icon-bell > .wp-block-group__inner-container:first,
      .wp-block-group.icon-bell > .wp-block-group:first`
      ).first();

      if (group.length >= 1) {
        group.prepend(iconBell[0].outerHTML);
      }
    }

    /**
     * Animate numbers
     */
    // post process headings to isolate numbers inside
    let $headings = $('.servier-key-figures h1');

    if ($headings.length) {
      $headings.each(function () {
        let $heading = $(this);
        $heading.html(
          $heading
            .html()
            .replace(/(\d+(\.\d+)?)/g, '<span class="number">$1</span>')
        );
      });

      // Counter Scroll Animation
      var launchAnimation = false;
      var lang = document.documentElement.lang;
      $(window).scroll(function () {
        var height = $(window).scrollTop();

        if ($('.servier-key-figures').length) {
          var hT = $('.servier-key-figures').offset().top;
          var wH = $(window).height();

          if (height >= hT - wH) {
            if (launchAnimation == false) {
              $('.servier-key-figures .number').each((index, element) => {
                let $elt = $(element);
                let text = $elt.text();
                let format = $elt.parent().data('format') == 1;
                let hasDecimal = text % 1;

                $elt.prop('Counter', 0).animate(
                  {
                    text,
                  },
                  {
                    duration: 4000,
                    easing: 'swing',
                    step: (now) => {
                      let num = now;

                      if (hasDecimal) {
                        if (lang === 'fr-FR') {
                          num = now.toFixed(1).replace('.', ',');
                        } else {
                          num = now.toFixed(1);
                        }
                      } else {
                        num = Math.ceil(now).toString();

                        if (format) {
                          if (lang === 'fr-FR') {
                            num = num.replace(
                              /(\d+)(\d{3})/,
                              '$1' + ' ' + '$2'
                            );
                          } else {
                            num = num.replace(
                              /(\d+)(\d{3})/,
                              '$1' + ',' + '$2'
                            );
                          }
                        }
                      }

                      $elt.text(num);
                    },
                  }
                );
              });
              launchAnimation = true;
            }
          }
        }
      });
    }

    // bsCustomFileInput
    $('.custom-file').each(function (index, item) {
      let $item = $(item);

      $item.parent().addClass('custom-file');
      $item.removeClass('custom-file');
      $item.addClass('custom-file-input');

      // check custom label
      let label = $item.data('file-label');
      if (!label) {
        label = $item.closest('[data-file-label]').data('file-label');
      }

      // label by default
      if (!label) {
        label =
          typeof Sage !== 'undefined' && Sage.attachFileLabel
            ? Sage.attachFileLabel
            : 'Attach a file';
      }

      let $label = $('<label>')
        .attr('for', $item.attr('id'))
        .addClass('custom-file-label')
        .html(label);

      $label.insertAfter($item);
    });
    bsCustomFileInput.init();

    // next posts button
    $('.nav-links .nav-previous').on('click', 'a', function (evt) {
      evt.preventDefault();
      let $button = $(this);
      var l = Ladda.create($button.get(0));
      l.start();
      $.get($button.attr('href'), function (html) {
        l.stop();

        let $html = $(html);
        let $newlist = $html.find('.servier-last-news .col-lg-3');
        $('.servier-last-news .row').append($newlist);

        let $pagination = $html.find('.nav-links .nav-previous a');
        if ($pagination.length) {
          $('.nav-links .nav-previous a').replaceWith($pagination);
        } else {
          $('.nav-links').remove();
        }
      });
    });

    // scroll to top button
    $('[data-scrolltop]').on('click', function (evt) {
      evt.preventDefault();
      $('html, body').animate({ scrollTop: 0 }, 1000);
    });

    // back button
    $('[data-back-button]').on('click', function (evt) {
      evt.preventDefault();
      window.history.back();
    });

    // scrollspy
    let $links = $('.navbar-nav .scrollanchor a');
    let $sections = [];
    let currentSectionId = false;
    let newSectionId = false;
    let $header = $('.site-header');

    $links.on('click', function (evt) {
      let href = $(this).attr('href');
      let selector = getSelector(href);
      if (selector) {
        let $section = $(selector);
        if ($section.length) {
          evt.preventDefault();
          if ($(window).width() < 991) {
            $($header.find('.navbar-toggler').attr('data-target')).collapse(
              'hide'
            );
          }
          let offset = $header.hasClass('shrink') ? 75 : -55;
          let newScrollTop = $section.offset().top + offset - 140;
          $('html, body').animate({
            scrollTop: newScrollTop,
          });
        }
      }
    });

    $links.each(function (index, item) {
      let href = $(item).attr('href');
      let selector = getSelector(href);
      if (selector) {
        let $section = $(selector);
        if ($section.length) {
          $sections.push($section);
        }
      }
    });

    function getSelector(href) {
      if (href) {
        let hashIndex = href.indexOf('#');
        if (hashIndex != -1 && href != '#') {
          return href.substr(hashIndex);
        }
      }
      return false;
    }

    $(window).scroll(onScroll);

    onScroll();

    let lastScrollTop = $(window).scrollTop();

    function onScroll() {
      let scrollTop = $(window).scrollTop();

      if (scrollTop > lastScrollTop) {
        $header.addClass('shrink');
      } else {
        $header.removeClass('shrink');
      }

      let screenCenterScrollTop = scrollTop + $(window).height() / 2;

      for (let i in $sections) {
        let $section = $sections[i];
        if (screenCenterScrollTop > $section.offset().top) {
          newSectionId = $section.attr('id');
        }
      }
      if (newSectionId != currentSectionId) {
        currentSectionId = newSectionId;
        $links.parent().removeClass('active');
        $links
          .filter('[href*="#' + currentSectionId + '"]')
          .parent()
          .addClass('active');
      }

      lastScrollTop = scrollTop;
    }

    /**
     * dropdown menus open:
     * - on mouseover on mobile
     * - on click on desktop
     **/
    function handleDropdowns() {
      let $childrenDropdown = $(
        '.menu-item-has-children.dropdown > .nav-link, .menu-item-has-children.dropdown > .dropdown-item'
      );

      if ($(window).width() < 991) {
        $childrenDropdown.attr('data-toggle', 'dropdown');
      } else {
        $childrenDropdown.removeAttr('data-toggle');
      }
    }
    $(window).resize(handleDropdowns);
    handleDropdowns();

    /**
     * add class on site header open
     */
    $('.navbarSupportedContent').on('show.bs.collapse', function () {
      $('.site-header').addClass('open');
    });
    $('.navbarSupportedContent').on('hide.bs.collapse', function () {
      $('.site-header').removeClass('open');
    });

    /**
     * block slider
     */
    $('.servier-slider .slides').slick({
      arrows: false,
      dots: true,
    });

    /**
     * block contact subjects
     */
    $('.servier-contact-subjects button.subject').on('click', function () {
      let buttonDataContactSubject = $(this).attr('data-contact-subject');
      setContactSubject(buttonDataContactSubject);
    });

    if (window.location.hash) {
      let hash = window.location.hash.substr(1);
      let $form = $(
        '.servier-contact-subjects .forms-container .item[data-contact-subject="' +
          hash +
          '"]'
      );
      if ($form.length) {
        setContactSubject(hash);
      }
    }

    // prepend back button to forms
    let servierContactSubjectsBackButton = $(
      '<button type="button" class="back"></button>'
    ).html($('.icons-js > .arrow-right').html());
    $('.servier-contact-subjects .forms-container .item').prepend(
      servierContactSubjectsBackButton
    );

    // on click, remove hash and display subjects again
    $('.servier-contact-subjects .forms-container .item button.back').on(
      'click',
      function (evt) {
        evt.preventDefault();
        window.history.replaceState(
          '',
          document.title,
          window.location.pathname
        );
        let $currentForm = $(
          '.servier-contact-subjects .forms-container .item:visible'
        );
        contactSubjectsAnimation(
          $currentForm,
          $('.servier-contact-subjects .buttons-container')
        );
      }
    );

    function setContactSubject(hash) {
      window.location.hash = hash;
      let $allForms = $('.servier-contact-subjects .forms-container .item');
      let $form = $allForms.filter(
        '.item[data-contact-subject="' + hash + '"]'
      );
      contactSubjectsAnimation(
        $('.servier-contact-subjects .buttons-container'),
        $form
      );
    }

    function contactSubjectsAnimation($elementToHide, $elementToShow) {
      let animationDuration = 750;
      $elementToHide.animate(
        {
          height: 'toggle',
          opacity: 'toggle',
        },
        animationDuration,
        function () {
          $elementToShow.animate(
            {
              height: 'toggle',
              opacity: 'toggle',
            },
            animationDuration
          );
        }
      );
    }

    /**
     * job board ajax pagination and sorting
     */
    $('.job-board').on('click', '.pagination a', function (evt) {
      evt.preventDefault();
      job_board_update(evt);
    });

    $('.job-board').on('change', '[name="orderby"]', function (evt) {
      evt.preventDefault();
      job_board_update(evt);
    });

    function job_board_update(evt) {
      let $element = $(evt.currentTarget);
      if ($element.length) {
        let url = window.location.href;

        if ($element.is('a')) {
          url = $element.attr('href');
        }

        let orderby = $('.job-board select[name="orderby"]').val();
        url += (url.includes('?') ? '&' : '?') + 'orderby=' + orderby;

        $.get(url, function (html) {
          let $html = $(html);
          let $newlist = $html.find('.posts-container');
          $('.posts-container').replaceWith($newlist);
        });
      }
    }

    /**
     * isotope medecines
     */
    let $grid = $('.page-container .medecines').imagesLoaded(function () {
      $grid.isotope({
        itemSelector: '.medecine',
        layoutMode: 'masonry',
        percentPosition: true,
        masonry: {
          columnWidth: '.grid-sizer',
          gutter: '.gutter-sizer',
        },
      });
    });

    /**
     * therapeutic areas filter medecines destkop
     */

    $('.servier-therapeutic-areas-list.interactive .area').on(
      'click',
      function () {
        if ($(this).hasClass('selected')) {
          $('.servier-therapeutic-areas-list .area').removeClass(
            'selected unselected'
          );
          $grid.isotope({ filter: '' });
        } else {
          $('.servier-therapeutic-areas-list .area')
            .removeClass('selected')
            .addClass('unselected');
          $(this).removeClass('unselected').addClass('selected');
          $grid.isotope({ filter: '.' + $(this).attr('data-slug') });
        }
      }
    );

    /**
     * therapeutic areas filter medecines mobile
     */
    $('.servier-therapeutic-areas-list select.mobile').on(
      'change',
      function () {
        let filter = $(this).val() ? '.' + $(this).val() : '';
        $grid.isotope({ filter: filter });
      }
    );

    /**
     * isotope news section
     */
    let $gridNewsSection = $('.page-container .news-section').imagesLoaded(
      function () {
        $gridNewsSection.isotope({
          itemSelector: '.news-section',
          layoutMode: 'masonry',
          percentPosition: true,
          masonry: {
            columnWidth: '.grid-sizer',
            gutter: '.gutter-sizer',
          },
        });
      }
    );

    /**
     * category filter news section destkop
     */

    $('.servier-category-block.interactive .category').on('click', function () {
      if ($(this).hasClass('selected')) {
        $('.servier-category-block .category').removeClass(
          'selected unselected'
        );
        $gridNewsSection.isotope({ filter: '' });
      } else {
        $('.servier-category-block .category')
          .removeClass('selected')
          .addClass('unselected');
        $(this).removeClass('unselected').addClass('selected');
        $gridNewsSection.isotope({ filter: '.' + $(this).attr('data-slug') });
      }
    });

    /**
     * category filter news section mobile
     */
    $('.servier-category-block select.mobile').on('change', function () {
      let filter = $(this).val() ? '.' + $(this).val() : '';
      $gridNewsSection.isotope({ filter: filter });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js